module.exports = __webpack_public_path__ + "img/redis.da5f72a5.svg";